module.exports = __webpack_public_path__ + "static/img/farmer.444114d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/farmer.jpg
// module id = KGNq
// module chunks = 4